import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { of, Subject } from 'rxjs';
import { AufnahmePunktDocument } from 'src/app/data-model';

import { DataService } from 'src/app/data.service';

const update = (bp: any) => {
}

export const bohrpunktDetailResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot) => {
    const ds = inject(DataService);

    const id = route.paramMap.get('id')!;
		const bpSubj = new Subject<any>;
		if (ds.isInitialized) {
			ds.getDocument$(id).subscribe((bp: any) => {
				bpSubj.next(ds.updateBohrpunkt(bp))
			});
		}
		else {
			ds.initialized.subscribe((db: PouchDB.Database) => {
				ds.getDocument$(id).subscribe((bp: any) => {
					bpSubj.next(ds.updateBohrpunkt(bp))
				});
			});
		}
		return bpSubj;
};

export const bohrpunkteDetailResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot) => {
	// Sofort leeres Array zurückgeben - die Komponenten laden die Punkte selbst
	// Das verhindert, dass die Navigation blockiert wird
	return of([]);
};

export function updateAccordingly(bp: any, bps: AufnahmePunktDocument[]) {
	return new Array(...bps.map((val: any, index: number, that: AufnahmePunktDocument[]) => {
		if (val._id === bp._id)
			return bp;
		else
			return val;
	}));
}
